import styled from "styled-components";

export const ContentAcademy = styled.main` 
  width: 100%;
  min-height: calc(100dvh - 90px - 126px);
  padding-bottom: 16px;
  background-color: #fafafa;
`;